export default __webpack_public_path__ + "static/media/heads-03.802506d8.svg";